import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Scene3D from "./Scene3D";
import { Reveal } from "../lib/motion";
import { BUSINESS } from "../content/defaults";

export default function ServiceSceneRow({ service, sceneSide, onBook }) {
  const scene = (
    <Reveal key="scene">
      <Scene3D variant={service.variant} />
    </Reveal>
  );
  const copy = (
    <Reveal key="copy" delay={0.1}>
      <div className="service-copy">
        <span className="eyebrow red">{service.title.toUpperCase()}</span>
        <h3>{service.heading}</h3>
        {service.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        <ul className="symptoms">
          {service.symptoms.map((s) => <li key={s}>{s}</li>)}
        </ul>
        <div className="row-actions">
          <button className="btn btn-blue" onClick={onBook} data-testid={`${service.id}-book-cta`}>
            {service.primary.label} <ArrowRight size={15} />
          </button>
          <button className="btn btn-ghost" onClick={() => onBook(true)} data-testid={`${service.id}-describe-cta`}>
            {service.primary.describe} <ArrowRight size={15} />
          </button>
        </div>
        <Link className="explore-link" to={`/services/${service.id}`} data-testid={`${service.id}-learn-link`}>
          Explore this service · 10 FAQs <ArrowRight size={13} />
        </Link>
        <p className="form-note" style={{ marginTop: 12 }}>{BUSINESS.address}</p>
      </div>
    </Reveal>
  );
  return (
    <div className="service-row" data-testid={`service-row-${service.id}`}>
      {sceneSide === "left" ? [scene, copy] : [copy, scene]}
    </div>
  );
}
